export const signIn = {
  forgotPasswordLink: "Forgot your password?",
  form: {
    submit: "Sign in",
  },
  title: "Sign in to your account",
};
